import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';

import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';

import ChecklistNextTaskButton from './ChecklistNextTaskButton';


const mapDispatchToProps = (dispatch, ownProps) => ({
  goToNextTask: () => {
    const currentTaskId = get(ownProps, 'params.id');
    dispatch(checklistV2Actions.handleGoToNextTask(currentTaskId));
  },
});

export default withRouter(connect(null, mapDispatchToProps)(ChecklistNextTaskButton));



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistNextTaskButton/index.js